import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scheme-registration-details',
  templateUrl: './scheme-registration-details.component.html',
  styleUrls: ['./scheme-registration-details.component.scss']
})
export class SchemeRegistrationDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
